
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default{
directives: {
TransferDom
},
components: {
XDialog
},
props: ["showScrollBox","data"],
methods: {
showSc(){
this.$emit('input', false)
}
}
}



// WEBPACK FOOTER //
// ./src/components/common/Agreement.vue